module.exports = __webpack_public_path__ + "img/image4.17725afb.png";